import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/projects/settings/page';

export const Route = createFileRoute('/_app/_chat/projects/$projectId/settings/')({
  component: Page,
});
